import { createIdentifier } from '@blocksuite/global/di';
import type { BlockStdScope } from '@blocksuite/std';
import type { ExtensionType } from '@blocksuite/store';
import type { ReadonlySignal } from '@preact/signals-core';

export interface TranslationService {
  readonly language$: ReadonlySignal<string>;
  translate(source: string): string;
}

export const TranslationProvider = createIdentifier<TranslationService>(
  'AffineTranslationProvider'
);

export function TranslationExtension(
  translationService: TranslationService
): ExtensionType {
  return {
    setup: di => {
      di.addImpl(TranslationProvider, () => translationService);
    },
  };
}

export function translate(
  std: BlockStdScope,
  source: string | undefined
): string | undefined {
  if (!source) return source;

  const service = std.getOptional(TranslationProvider);
  if (!service) return source;

  void service.language$.value;
  return service.translate(source);
}
